import { render, staticRenderFns } from "./MeezanPaymentGateway.vue?vue&type=template&id=5bbb6db5&scoped=true&"
import script from "./MeezanPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./MeezanPaymentGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbb6db5",
  null
  
)

export default component.exports